export default __webpack_public_path__ + "static/media/whatsappSlide2.427ada7b.svg";